<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-dialog
    v-model="dialog"
    persistent
    id="support"
    width="1000px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title class="py-6">
        <div
          class="text-h6 text-sm-h4"
          style="word-break: break-word;"
        >{{ language.t('RoadProfiler.Support.titleLinks') }}</div>
        <v-spacer></v-spacer>
        <v-btn
          icon
          color="blue darken-1"
          @click="$emit('close');"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-6">
        <ul>
          <li><a
              href="/manuals/NL%20312_100004_20170608%20RPR-1%20Road%20Profiler%20Taakdata%20specificatie.pdf"
              download
            >{{ language.t('RoadProfiler.Support.manualTaskDataPrep') }}</a></li>
          <li><a
              href="/manuals/NL%20310_100007_20181029%20RPR-1%20Road%20Profiler%20Handleiding.pdf"
              download
            >{{
              language.t('RoadProfiler.Support.manualUser')
            }}</a></li>
          <li><a
              href="/manuals/NL%20311_100007_20181029%20RPR-1%20Road%20Profiler%20Snelstartgids.pdf"
              download
            >{{
              language.t('RoadProfiler.Support.quickstartSheet')
            }}</a></li>
          <li><a
              href="https://www.tyker.com/roadprofiler/"
              target="_blank"
            >{{
              language.t('RoadProfiler.Support.website')
            }}</a></li>
        </ul>
      </v-card-text>
    </v-card>

    <v-card class="mt-2">
      <v-card-title class="py-6">
        <div
          class="text-h6 text-sm-h4"
          style="word-break: break-word;"
        >{{ language.t('RoadProfiler.Support.titleCall') }}</div>
      </v-card-title>
      <v-card-text>
        <p>{{ language.t('RoadProfiler.Support.supportCall') }}</p>
        <h2>+31 (0)85 48 24 811</h2>
      </v-card-text>
      <v-card-actions class="card-actions">
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="$emit('close');"
        >
          <v-icon>mdi-close</v-icon>{{ language.t('App.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      dialog: true,
    };
  },
  mounted: function () { },
  computed: {},
  watch: {},
  methods: {
    onClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
#support {
  max-width: 1000px;
}
</style>
